import styled from 'styled-components';
import { BREAKPOINTS } from 'styles/media';

export const ResourceSubmissionCategoryWrapper = styled.div`
  display: flex;
  flex-direction: column;

  gap: 24px;
`;

export const ResourceSubmissionCategoriesWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(157px, 1fr));

  gap: 8px;

  ${({ theme }) =>
    theme.isError &&
    `
    border-radius: 20px;
    outline: 1px solid var(--color-error);
  `}

  ${BREAKPOINTS.tablet} {
    grid-template-columns: repeat(1, 100%);
    gap: 16px;
  }
`;

export const ResourceSubmissionCategoryIconContainer = styled.div`
  width: 40px;
  height: 40px;

  min-width: 40px;
  min-height: 40px;

  display: flex;
  justify-content: center;
  align-items: center;

  border-radius: 100%;
  border: 1px solid #000;
  background: #fff;
  padding: 5px;
`;

export const ResourceSubmissionCategoryIcon = styled.img`
  width: 28px;
  height: 28px;

  min-width: 28px;
  min-height: 28px;

  object-fit: contain;
`;

interface ResourceSubmissionCategoryContainerProps {
  active: boolean;
}

export const ResourceSubmissionCategoryContainer = styled.button<ResourceSubmissionCategoryContainerProps>`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;

  padding: 8px 24px;

  ${({ active }) =>
    active
      ? `
      border: 1px solid #000000;

      box-shadow: inset 0 0 0 1px #000;
    `
      : `
      border: 1px solid rgba(255, 255, 255, 0.5);
      `}

  font: inherit;
  &:focus-visible {
    outline: 3px solid #000;
    outline-offset: 3px;
  }
  transition: all 0.3s ease;

  border-radius: 32px;
  background: radial-gradient(
    111.84% 97.93% at 10.92% 6.88%,
    rgba(255, 250, 250, 0.08) 0%,
    rgba(212, 212, 212, 0.01) 100%
  );
  box-shadow: 0 6px 24px 0 rgba(65, 81, 100, 0.2);
  backdrop-filter: blur(3px);

  ${BREAKPOINTS.tablet} {
    gap: 8px;

    padding: 8px;
  }

  cursor: pointer;
`;

export const ResourceSubmissionCategoryName = styled.span`
  font-weight: 400;
  font-size: 18px;
  line-height: normal;
  text-align: center;

  ${BREAKPOINTS.tablet} {
    font-size: 16px;
  }

  color: var(--color-text);
`;

//GUIDELINE
export const ResourceSubmissionCategoryGuidelineContainer = styled.div`
  min-height: 116px;

  display: flex;
  align-items: center;
  justify-content: center;

  border-radius: 32px;
  border: 2px solid rgba(255, 255, 255, 0.5);

  cursor: pointer;
`;

export const ResourceSubmissionCategoryGuidelineName = styled.span`
  font-weight: 400;
  font-size: 18px;
  line-height: normal;
  text-align: center;

  color: var(--color-text);
`;

export const ResourceSubmissionCategoryGuidelineNameUnderline = styled(
  ResourceSubmissionCategoryGuidelineName
)`
  text-decoration: underline;
`;
